import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React from "react";
import { InputProps } from "./InputProps";
import { SelectFormInputOption } from "./SelectFormInput";
import { colors } from "../../theme";
import { useApi } from "../../contexts/ApiContext";

export interface RadioInputOption extends SelectFormInputOption {
  label: string;
  value: string;
}

export type RadioInputPropsType = InputProps & RadioInputOption;

export interface CheckboxesInputProps
  extends Omit<Omit<RadioInputPropsType, "onChange">, "value"> {
  onChange: (values: RadioInputOption | null) => void;
  options: RadioInputOption[];
  caption?: string;
  value?: RadioInputOption;
}
const RadioInput: React.FC<CheckboxesInputProps> = ({
  label,
  onChange,
  error,
  helperText,
  options,
  caption,
  value = null,
}) => {

  const { isSubmitting, isLoading } = useApi();
  const isDisabled = isLoading || isSubmitting;

  return (
    <FormControl disabled={isDisabled}>
      <FormLabel error={error}>{label}</FormLabel>
      {caption && (
        <Typography color={"greyButton"} variant={"caption"}>
          {caption}
        </Typography>
      )}
      <RadioGroup
        name={label}
        value={value?.value || ""} 
        onChange={(_ev, newVal: string) =>
          onChange(options.find((o) => o.value === newVal) ?? null)
        }
      >
        {options.map((option: RadioInputOption) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio color={"default"} sx={{color: colors.stone[900]}} />}
            label={option.label}
          />
        ))}
      </RadioGroup>

      <FormHelperText>{helperText ? helperText : " "}</FormHelperText>
    </FormControl>
  );
};

export default RadioInput;
